module.exports = __webpack_public_path__ + "static/media/PortEDI_BackImage.7956a823.jpg";